import React from "react";

// Create a context with default values
const MyContext = React.createContext({
  //Authentication
  dataFetched: false,
  getIp: false,
  headers: "",
  idVerification: false,
  idVerificationRequired: false,
  idVerificationFailed: false,
  requestAuthentication: false,

  //Dev or Production
  dev: false,

  //Data
  data: {},

  //Data Updated
  dataUpdated: false,

  //Docs
  // docsData: {},
  pdfDocData: {},
  idDocData: {},
  proofOfAddressData: {},
  proofOfIncomeData: {},
  bankStatementData: {},
  docsSubmitted: false,
  docsSent: false,
  docsError: false,
  docsResponse: "",

  //Lead Errors
  acceptTermsError: "",
  acceptOneVapTermsError: "",
  ageError: "",
  altNumberError: "",
  consentBureauInformationError: "",
  consentFraudIdentityCheckError: "",
  contactNumberError: "",
  formError: "",
  homeNumberError: "",
  idNumberError: "",
  mobileError: "",
  postalCodeError: "",
  postalPostalCodeError: "",
  signatureError: "",
  underAdministrativeOrderError: "",
  underDebtReviewError: "",
  underSequestrationError: "",
  vehicleYearError: "",
  witnessContactNumberError: "",
  workNumberError: "",

  //Insurance Errors
  addressSameError: "",
  addressSecureError: "",
  antiTheftInstalledError: "",
  code3Error: "",
  immobiliserError: "",
  modificationsError: "",
  selectError: "",
  vehiclesError: "",

  //Laminin
  lamininSubmitted: false,
  lamininSent: false,
  lamininError: false,
  lamininResponse: "",

  //Lead Forms
  addressDataCaptured: false,
  customerDataCaptured: false,
  docsDataCaptured: false,
  declarationDataCaptured: false,

  //Insurance Forms
  captureVehicle: false,
  dayAddressDataCaptured: false,
  financeDataCaptured: false,
  insuranceDataCaptured: false,
  insuredDataCaptured: false,
  nightAddressDataCaptured: false,
  quoteDataCaptured: false,
  registeredOwnerDataCaptured: false,
  regularDriverDataCaptured: false,
  riskAddressDataCaptured: false,
  vehicleDataCaptured: false,
  vehiclesDataCaptured: false,
  vehicles: false,
});

export default MyContext;
